import { Api } from 'api';
import { BackendFirm, Firm } from 'api/interfaces/firm';
import { Dispatch } from 'redux';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { ApplicationState } from 'redux/applicationState';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const getFirmsById =
  (id: string | number) =>
  (dispatch: Dispatch<Action<FirmsActions>>, _: () => ApplicationState, api: Api): VoidFunction => {
    dispatch(createAction(FirmsActions.getFirmsByIdStarted));
    const task = api.getFXOFirmsById(id);

    task
      .run()
      .then((firms: BackendFirm[]): void => {
        dispatch(createAction(FirmsActions.getFirmsByIdCompleted, firms.map(Firm.fromBackendFirm)));
      })
      .catch((error: any): void => {
        dispatch(createAction(FirmsActions.getFirmsByIdFailed, error));
      });

    return (): void => {
      task.cancel();
    };
  };
